import { z } from "zod";
import { getCustomerCreateFormSchema } from "./customerCreateSchema";

export const getOrderCreateManualFormSchema = () => {
	return z.object({
		marketId: z.number(),
		verticalId: z.number(),
		marketRegionId: z.number().nullish(),
		address: z.string(),
		customer: z.object(getCustomerCreateFormSchema().shape),
	});
};

export type OrderCreateManualFormModel = z.infer<
	ReturnType<typeof getOrderCreateManualFormSchema>
>;
